import React from 'react';
import {Container, Title, Description} from './styles';

const Header = ({title, description}) => (
  <Container>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </Container>
);

export default Header;